
import { IPSAdditionalField } from '@/types/processingSteps'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class AdditionalStepMixin extends Vue {
  isCharField (field: IPSAdditionalField) {
    return field.input_type.value === 1
  }

  isTextField (field: IPSAdditionalField) {
    return field.input_type.value === 2
  }

  isDocumentField (field: IPSAdditionalField) {
    return field.input_type.value === 3
  }

  isCheckboxField (field: IPSAdditionalField) {
    return field.input_type.value === 4
  }

  isSelectField (field: IPSAdditionalField) {
    return field.input_type.value === 5
  }

  isHtmlField (field: IPSAdditionalField) {
    return field.input_type.value === 6
  }

  isIntegerField (field: IPSAdditionalField) {
    return field.input_type.value === 7
  }

  isCurrencyField (field: IPSAdditionalField) {
    return field.input_type.value === 9
  }

  isDateField (field: IPSAdditionalField) {
    return field.input_type.value === 10
  }
}
